export const findLocales = language => {
  return localStorage.getItem("locales") === language;
};
